var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelDigitalAd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2.859l-1.862-4.609 1.138-.05c.862-.036 1.275-1.073.676-1.693L11.039 8.42c-.625-.646-1.718-.205-1.719.694l-.005 7.279c0 .86 1.015 1.32 1.661.75l.859-.755L13.294 20H5a1 1 0 0 1-1-1z",
  clipRule: "evenodd"
})));
export default SvgGemChannelDigitalAd;